export type PurchaseType = 'PCS' | 'PACK' | 'HALF_PACK'

export interface Product {
  id: number
  name: string
  category: string | null
  pricePcs: number | null
  pricePack: number | null
  priceHalfPack: number | null
  active: boolean
  createdAt: string
  updatedAt: string
}

export interface ProductPriceForm {
  pcs?: number
  pack?: number
  halfPack?: number
}

export interface CartItem {
  productId: number
  productName: string
  purchaseType: PurchaseType
  quantity: number
  unitPrice: number
  subtotal: number
}

export interface OrderSummary {
  outletName: string
  items: CartItem[]
  total: number
}

export const PURCHASE_TYPE_LABELS: Record<PurchaseType, string> = {
  PCS: 'PCS',
  PACK: '1 Pack',
  HALF_PACK: '1/2 Pack',
}

export const PURCHASE_TYPE_KEYS: PurchaseType[] = ['PCS', 'PACK', 'HALF_PACK']

export function getAvailablePurchaseTypes(product: Product): PurchaseType[] {
  return PURCHASE_TYPE_KEYS.filter((type) => {
    switch (type) {
      case 'PCS':
        return product.pricePcs !== null && product.pricePcs !== undefined && product.pricePcs > 0
      case 'PACK':
        return product.pricePack !== null && product.pricePack !== undefined && product.pricePack > 0
      case 'HALF_PACK':
        return product.priceHalfPack !== null && product.priceHalfPack !== undefined && product.priceHalfPack > 0
    }
  })
}

export function getPriceForType(product: Product, type: PurchaseType): number | undefined {
  switch (type) {
    case 'PCS':
      return product.pricePcs || undefined
    case 'PACK':
      return product.pricePack || undefined
    case 'HALF_PACK':
      return product.priceHalfPack || undefined
  }
}

export function formatRupiah(amount: number): string {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

export function productToFormData(product: Product): ProductPriceForm {
  return {
    pcs: product.pricePcs ?? undefined,
    pack: product.pricePack ?? undefined,
    halfPack: product.priceHalfPack ?? undefined,
  }
}

export function formDataToPrices(form: ProductPriceForm): { pricePcs: number | null; pricePack: number | null; priceHalfPack: number | null } {
  return {
    pricePcs: form.pcs !== undefined && form.pcs !== null && form.pcs > 0 ? form.pcs : null,
    pricePack: form.pack !== undefined && form.pack !== null && form.pack > 0 ? form.pack : null,
    priceHalfPack: form.halfPack !== undefined && form.halfPack !== null && form.halfPack > 0 ? form.halfPack : null,
  }
}